import React from 'react';
import cx from 'classnames';
import { useServerData } from '@xingternal/hops';
import styles from './CompanyCardContainer.css';

const CompanyCardContainer = ({
  children,
  dataTestId,
}: {
  children: JSX.Element[];
  dataTestId: string;
}) => {
  const { authenticated } = useServerData();

  return (
    <div
      data-testid={dataTestId}
      className={cx(styles.layout, 'container-company-card')}
    >
      {children.map((child, i) => (
        <div
          key={`companyCard-${i}`}
          className={cx(
            styles.wrapper,
            authenticated ? styles.loggedInWrapper : styles.loggedOutWrapper,
          )}
        >
          {child}
        </div>
      ))}
    </div>
  );
};
CompanyCardContainer.defaultProps = {
  children: [],
  dataTestId: 'container-company-card',
};
export { CompanyCardContainer };
